import { ArticleListFieldsFragment } from '@src/generated/graphql';
import { highlightBracketedText } from 'src/utils/utils';
import { DynamicLink, GridBlock, SectionWrapper, Typography } from 'src/components/shared';

type NewsComponentProps = {
  content?: ArticleListFieldsFragment;
};

const NewsComponent = ({ content }: NewsComponentProps) => {
  const newsItems = content?.articlesCollection?.items || [];
  const headerText = content?.title ?? '';

  const viewMoreLabel = content?.button;
   
  return (
    <SectionWrapper className="news-component-block" id="news">
      <div className="container-fluid custom-spacer-col">
        <div className="row">
          <div className="col-md-12 col-sm-12 text-left">
            <div className="component-title">
              <span  
                  className='highlight-bracket-text'
                 dangerouslySetInnerHTML={{ __html: highlightBracketedText(headerText ?? "" , "bold") }}  
             />
            </div>
          </div>
        </div>

        <div className="grid-block-main-wrap grid-img-cards">
          <div className="grid-block-main-items" style={{justifyContent:"start"}}>
            {newsItems.map((item, index) => (
              <GridBlock
                key={index}
                image={item?.thumbnailImage ?? ''}
                icon={item?.mainImage ?? ""}
                title={item?.title ?? ''}
                subDescription={item?.subDescription ?? ""}
                linkText={item?.articleLink?.linkText ?? ''}
                link={item?.articleLink?.linkUrl ?? 'https.example.com'}
                typographyClassName="fw-bold mb-0"
                isOverLay
                isFirstCard={index===0}
              />
            ))}
          </div>
        
        </div>
      </div>
    </SectionWrapper>
  );
};

export default NewsComponent;
